import { useAppNavigate } from '../../Hooks/back/useAppNavigate';
import { useSelector } from 'react-redux';
import Icon from '../../Assets/Icon/CustomIcon';

export default function WriteFAB({ handleWriteClick }) {
  const { navigate } = useAppNavigate();
  const { navBar } = useSelector((state) => state.systemBar);

  return (
    <button
      className="bg-secondary fixed right-5 z-1 flex h-14 w-14 cursor-pointer items-center justify-center overflow-hidden rounded-full border-none shadow-[0_3px_8px_rgba(0,0,0,0.24)] transition-transform active:scale-95"
      style={{ bottom: `${navBar + 20}px` }}
      onClick={() => {
        navigate('/M_Permit/write');
        handleWriteClick();
      }}
    >
      <Icon.Edit className="h-6 w-6 text-white" />
    </button>
  );
}
